// theme constant
export const gridSpacing = 3;
export const drawerWidth = 200;
export const appDrawerWidth = 320;

// layout constants
export const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    HORIZONTAL_LAYOUT: 'horizontal'
} as const;

export const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    backgroundColor: 'dark.light'
};
